import React from "react"
import PropTypes from "prop-types"
import Layout from "components/molecules/Layout"
import SEO from "components/molecules/SEO"

import { CollectionNotice } from "components/molecules/PublicInformation"
import ContactModal from "components/content/ContactModal"

const ContactPage = ({ pageContext: { language } }) => {
  return (
    <Layout language={language}>
      <SEO title="Contact" />
      <CollectionNotice />
      <ContactModal asPage />
    </Layout>
  )
}

ContactPage.propTypes = {
  pageContext: PropTypes.shape({
    language: PropTypes.string,
  }).isRequired,
}

export default ContactPage
